import { Component, OnInit } from "@angular/core";
import {
    FormControl,
    ReactiveFormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import PasswordConfirm from "./../../../_app-core/_utils/password-match";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-supplier-change-password",
    templateUrl: "./supplier-change-password.component.html",
    styleUrls: ["./supplier-change-password.component.scss"],
})
export class SupplierChangePasswordComponent implements OnInit {
    isLoading = false;
    isError = false;
    responseData: any;

    passwordData = new FormGroup(
        {
            // oldPassword: new FormControl(null, Validators.required),
            newPassword: new FormControl(null, [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(15),
                // Validators.pattern(
                //   '^(?=.*[0-9])(?=.*[a-z])(?=.*[*.!@$%^&(){}[]:;<>,.?/~_+-=|]).{8}$'
                // ),
            ]),
            confirmPassword: new FormControl(null, Validators.required),
        },
        {
            validators: [
                PasswordConfirm.match("newPassword", "confirmPassword"),
            ],
        }
    );

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService
    ) {}

    mandatoryPasswordChange() {
        const userData = {
            username: localStorage.getItem("vendorCode"),
            password1: this.passwordData.value.newPassword,
            password2: this.passwordData.value.newPassword,
            "q1": " ",
            "a1": " ",
            "q2": " ",
            "a2": " ",
            "reqType": "onboard"
        };

        this.isLoading = true;

        this.authService.forceChangePassword(userData).subscribe(
            (res) => {
                this.isLoading = false;
                this.responseData = res;
                if (this.responseData.status == "success") {
                    console.log("Success");
                    this.authService.setOnboardingStatus(true);
                    this.router.navigateByUrl("/purchase-orders");
                } else {
                    this.isError = true;
                    console.log("error response body");
                }
            },
            (error) => {
                console.log("Error");
            }
        );
        //console.log(userData);
    }

    ngOnInit(): void {}
}
